import { OptsJson } from "types/opts-json";

export default class OptsJsonUtil {
  public static isOptsJson(arg: any): arg is OptsJson {
    return (
      arg !== null && "input" in arg && "output" in arg && "transform" in arg
    );
  }

  public static isIofileJson(arg: any): arg is OptsJson {
    return (
      arg !== null &&
      "local_path" in arg &&
      "file_type" in arg &&
      "parameter" in arg
    );
  }
}
